import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=07adbe78&scoped=true&"
import script from "./Permissions.vue?vue&type=script&setup=true&lang=js&"
export * from "./Permissions.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07adbe78",
  null
  
)

export default component.exports